/* Shorebird v2 product page: variants, gallery, add to cart (theme cart drawer), sticky bar */
(function () {
  if (customElements.get('s2-product')) return;

  function money(cents, format) {
    var value = parseInt(cents, 10) || 0;
    var fmt = format || '${{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function delimit(precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = delimit(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(2, "'", '.'); break;
      case 'amount_with_space_separator': out = delimit(2, ' ', ','); break;
      default: out = delimit(2, ',', '.');
    }
    return match ? fmt.replace(match[0], out) : out;
  }

  customElements.define('s2-product', class extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-s2-variants]');
      try { this.variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { this.variants = []; }
      this.format = this.dataset.moneyFormat;
      this.labels = {
        add: this.dataset.addLabel || 'Add to cart',
        soldOut: this.dataset.soldOutLabel || 'Sold out',
        unavailable: this.dataset.unavailableLabel || 'Unavailable',
        save: this.dataset.saveLabel || ''
      };
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.idInput = this.querySelector('[data-s2-id]');
      this.atc = this.querySelector('[data-s2-atc]');
      this.stickyBtn = this.querySelector('[data-s2-sticky-btn]');
      this.track = this.querySelector('[data-s2-gal-track]');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-s2-thumb]'));
      this.sticky = this.querySelector('[data-s2-sticky]');
      var startId = this.idInput ? String(this.idInput.value) : '';
      this.current = this.variants.find(function (v) { return String(v.id) === startId; }) || null;

      this.addEventListener('change', (event) => {
        if (event.target.closest('[data-s2-option]')) this.onOptionChange();
      });
      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!this.current || !this.current.available) return;
          this.add([{ id: this.current.id, quantity: 1 }], this.atc);
        });
      }
      this.addEventListener('click', (event) => {
        var quick = event.target.closest('[data-s2-quick]');
        if (quick) { event.preventDefault(); this.add([{ id: Number(quick.dataset.s2Quick), quantity: 1 }], quick); return; }
        var thumb = event.target.closest('[data-s2-thumb]');
        if (thumb) { event.preventDefault(); this.goTo(Number(thumb.dataset.s2Thumb), true); return; }
        var stickyBtn = event.target.closest('[data-s2-sticky-btn]');
        if (stickyBtn && this.form) {
          event.preventDefault();
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
          else if (this.atc) this.atc.click();
        }
      });
      if (this.track) {
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => this.syncThumbs(), 80);
        }, { passive: true });
      }
      if (this.current && this.current.featured_media) this.goToMedia(this.current.featured_media.id, false);
      this.markAvailability();
      this.setupSticky();
    }

    selectedOptions() {
      return Array.prototype.map.call(this.querySelectorAll('[data-s2-option]'), function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    onOptionChange() {
      var selected = this.selectedOptions();
      this.querySelectorAll('[data-s2-option]').forEach(function (fieldset, i) {
        var out = fieldset.querySelector('[data-s2-opt-value]');
        if (out) out.textContent = selected[i] || '';
      });
      this.current = this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      }) || null;
      this.markAvailability();
      this.render();
    }

    markAvailability() {
      var selected = this.selectedOptions();
      var variants = this.variants;
      this.querySelectorAll('[data-s2-option]').forEach(function (fieldset, i) {
        fieldset.querySelectorAll('input').forEach(function (input) {
          var test = selected.slice();
          test[i] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return o === test[j]; });
          });
          var pill = input.closest('.s2-pill');
          if (pill) pill.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    priceHTML(v) {
      var html = '<span class="s2-price__now">' + money(v.price, this.format) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s class="s2-price__was">' + money(v.compare_at_price, this.format) + '</s>';
        if (this.labels.save) {
          html += '<span class="s2-price__save">' + this.labels.save.replace('[amount]', money(v.compare_at_price - v.price, this.format)) + '</span>';
        }
      }
      return html;
    }

    render() {
      var v = this.current;
      if (this.idInput) this.idInput.value = v ? v.id : '';
      var label = !v ? this.labels.unavailable : (v.available ? this.labels.add : this.labels.soldOut);
      [this.atc, this.stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !v || !v.available;
        var labelEl = btn.querySelector('[data-s2-atc-label]') || btn;
        labelEl.textContent = label;
      });
      if (!v) return;
      var html = this.priceHTML(v);
      this.querySelectorAll('[data-s2-price]').forEach(function (el) { el.innerHTML = html; });
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
      if (v.featured_media) this.goToMedia(v.featured_media.id, true);
    }

    goToMedia(mediaId, smooth) {
      var slide = this.querySelector('[data-s2-media-id="' + mediaId + '"]');
      if (slide) this.goTo(Number(slide.dataset.s2Index), smooth);
    }

    goTo(index, smooth) {
      if (!this.track) return;
      var slide = this.track.children[index];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      this.setActiveThumb(index);
    }

    syncThumbs() {
      if (!this.track || !this.track.clientWidth) return;
      this.setActiveThumb(Math.round(this.track.scrollLeft / this.track.clientWidth));
    }

    setActiveThumb(index) {
      this.thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }

    add(items, btn) {
      var errorEl = this.querySelector('[data-s2-error]');
      if (errorEl) errorEl.hidden = true;
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      var drawer = document.querySelector('cart-drawer');
      var useDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
      var body = { items: items };
      if (useDrawer) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
      var self = this;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) { if (!res.ok) throw data; return data; });
        })
        .then(function (data) {
          if (useDrawer && data.sections) {
            try {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
              return;
            } catch (e) { /* fall through to cart page */ }
          }
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
            errorEl.hidden = false;
          }
        })
        .then(function () {
          if (!btn) return;
          btn.classList.remove('is-loading');
          if (btn === self.atc) btn.disabled = !(self.current && self.current.available);
          else btn.disabled = false;
        });
    }

    setupSticky() {
      if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
      var sticky = this.sticky;
      this.observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      this.observer.observe(this.atc);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
})();